import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'PillsTag',
  props: {
  total: Number,
  text: String,
  textColor: String,
  displayEmptyPill: Boolean
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      class: _normalizeClass([__props.textColor ?? ''])
    }, _toDisplayString(__props.text), 3),
    (__props.total || __props.displayEmptyPill)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass([ __props.displayEmptyPill && !__props.total? 'is-empty' : 'is-info', 'tag' ])
        }, _toDisplayString(__props.total), 3))
      : _createCommentVNode("", true)
  ], 64))
}
}

})